import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/async'
import makeAnimated from 'react-select/animated'
import { getRepresentatives } from "../actions/RepresentativeActions";

const animatedComponent = makeAnimated();
class RepresentativePicker extends Component {

    loadOptions(searchTerm, callback) {
        this.props.getRepresentatives(searchTerm).then((response) => {
          //  console.log(response)
            if (response && response.value.status === 200 && response.value.data && response.value.data.result) {
                const representativesList = response.value.data.result.map(c => ({
                    label: c.name, value: c.id, name: c.name, id: c.id, pictureUrl: c.pictureUrl, facebookUrl: c.facebookUrl, twitterUrl: c.twitterUrl,
                    instagramUrl: c.instagramUrl, youtubeUrl: c.youtubeUrl, linkedinUrl: c.linkedinUrl, pinterestUrl: c.pinterestUrl
                })) || [];
                callback(representativesList);
            }
        }, (error) => {

        });

    }

    render() {
        const { style, placeholder, onChange, defaultValue, isMulti } = this.props;
        return <div style={style}>
            <AsyncSelect components={animatedComponent} isMulti={isMulti} placeholder={placeholder} loadOptions={this.loadOptions.bind(this)} onChange={onChange} defaultValue={defaultValue} />
        </div>
    }
}

function mapStateToProps({ settings }, ownProps) {
    return { settings, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, { getRepresentatives})(RepresentativePicker));
